module.exports = __webpack_public_path__ + "static/img/ticket.70af7a35.svg";